const BFColors = {
  teal: "#75FAD4",
  calmBlue: "#286588",
  calmBlue50: "#1d4261",
  midnightBlue: "#121F3A",
  midnightGreen: "#144460",
  warmGrey: "#A7A4A4",
  neonYellow: "#F4FA58",
  alertGreen: "#2ADC83",
  beige: "#DFCDB9",
  redOrange: "#E14A3E",
  salmon: "#FC7792",
  darkGrey: "#676080",
  darkest11: "#000000CC",
  lightGrey: "#D9D9D9",
  lightest: "#FFFFFF",
  darkest: "#000000",
  wireFramesGrey: "#667080",
  offWhite: "#FAFAFA",
  fsGradientStart: "#121F3A",
  fsGradientEnd: "#0E3E77",
}

const tintColorLight = BFColors.calmBlue
const tintColorDark = "#fff"

const ThemeColors = {
  light: {
    text: "#000",
    background: "#fff",
    tint: tintColorLight,
    tabIconDefault: "#ccc",
    tabIconSelected: tintColorLight,
  },
  dark: {
    text: "#fff",
    background: "#000",
    tint: tintColorDark,
    tabIconDefault: "#ccc",
    tabIconSelected: tintColorDark,
  },
}

export { ThemeColors, BFColors }
